import clsx from 'clsx'
import { resolvePublicStorageURL } from '~/features/file-storage/storage-paths'

type Props = {
  size?: number
  src: string
  className?: string
}
export function OrganizationLogo({ src, className, size = 80 }: Props) {
  return (
    <img
      src={resolvePublicStorageURL(src)}
      className={clsx('object-contain', className)}
      style={{ maxWidth: `${size * 2}px`, height: `${size}px` }}
    />
  )
}
